/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality.
 */

import { localDatetime } from "commonAssets/lib/localDatetime";

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    // Deficiency portal: the standard claim-form deadline heading does not
    // apply to the Fix Claim flow, so remove it once the form has rendered.
    const claimFormDeadline = document.getElementById("claimFormDeadline");
    if (claimFormDeadline) {
        claimFormDeadline.remove();
    }

    // Prefilled First/Last name are locked; empty (unlisted) names stay editable.
    ["first_name", "last_name"].forEach((id) => {
        const field = document.getElementById(id);
        if (field) {
            field.disabled = Boolean(field.value);
        }
    });

    // Stamp the deficiency response received timestamp (captured on submit).
    const responseReceived = document.getElementById(
        "deficiency_response_received"
    );
    if (responseReceived) {
        responseReceived.value = localDatetime();
    }

    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    // Payment on file: seed the on-file sentinel BEFORE dstMember() runs so the
    // built-in "payment on file / choose a different method" message renders and
    // Section III selection becomes optional (Ops WP-1415). The flag is persisted
    // to claim.data.has_payment_info by the deficiency gate (SubmitClaim gate).
    if (claim?.data?.has_payment_info) {
        const pm = document.querySelector("#payment_method");
        const pt = document.querySelector("#payment_token");
        if (pm && !pm.value) pm.value = "On_File";
        if (pt && !pt.value) pt.value = "On_File";
    }
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    // custom code goes here
    return claim;
}
